export default __webpack_public_path__ + "2dfca0045baa0bbee9a23f79079146e2.png";